import api from '@/api';

const { $academic } = api;


export const { $certificates } = $academic;

